var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettings(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M14.061 3.25a2.61 2.61 0 003.878 0L19.2 1.868a2.612 2.612 0 014.547 1.884l-.095 1.866a2.61 2.61 0 002.735 2.739l1.866-.095a2.612 2.612 0 011.88 4.547l-1.389 1.253a2.613 2.613 0 000 3.879l1.39 1.253a2.612 2.612 0 01-1.885 4.547l-1.866-.095a2.611 2.611 0 00-2.742 2.742l.095 1.866a2.612 2.612 0 01-4.536 1.88l-1.255-1.388a2.612 2.612 0 00-3.877 0l-1.26 1.388a2.612 2.612 0 01-4.541-1.877l.096-1.867a2.61 2.61 0 00-2.742-2.741l-1.866.095A2.61 2.61 0 011.867 19.2l1.388-1.253a2.614 2.614 0 000-3.879l-1.388-1.26a2.61 2.61 0 011.878-4.541l1.867.094a2.61 2.61 0 002.744-2.746l-.09-1.868a2.612 2.612 0 014.542-1.88l1.253 1.384z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M16 22.001a6 6 0 100-12 6 6 0 000 12z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgSettings;